<template>
  <div class="flex-column vh">
    <Navbar />
    <router-view style="flex: 1"></router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@components/Navbar.vue";
import Footer from "@components/Footer.vue";
export default {
  name: "Index",
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
